import { render, staticRenderFns } from "./ProjectLiegenshaftStatus.vue?vue&type=template&id=505f3f4a&scoped=true&"
import script from "./ProjectLiegenshaftStatus.vue?vue&type=script&lang=ts&"
export * from "./ProjectLiegenshaftStatus.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectLiegenshaftStatus.vue?vue&type=style&index=0&id=505f3f4a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505f3f4a",
  null
  
)

export default component.exports